module.exports = __webpack_public_path__ + "static/media/anggaran.d9c6d9e2.png";